/**
 * The browser's IANA time zone ("America/Los_Angeles"), or undefined when it cannot be read.
 *
 * The reply routes take it so the server can write times in the user's own clock (the slot picker's
 * mornings and afternoons, "Thu Oct 15, 2:00 PM PT"). Undefined means "leave the parameter off", never
 * a guessed zone: a wrong zone would put the wrong day on a slot the user then offers a recruiter.
 */
export function userTimeZone() {
  try {
    const zone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof zone === "string" && zone !== "" ? zone : undefined;
  } catch (e) {
    return undefined;
  }
}
